import React from 'react';

import UI from '#front-credpago';

import useResizer from '../../../utils/useResizer';
import * as S from './styles';

const descriptions = [
  {
    id: 1,
    text: 'A CredPago tem como maior propósito facilitar o acesso a moradia, levando para as pessoas mais comodidade, segurança e liberdade através das suas soluções, ferramentas e serviços.',
  },

  {
    id: 2,
    text: 'É nesse sentido que inspiramos o nosso time: só faz sentido fazer algo, se isso impactar positivamente a vida de alguém. Não é a toa que, em 2020, conquistamos o selo RA 1000 no site Reclame Aqui, que nos identifica como uma empresa excelente no atendimento humanizado.',
  },

  {
    id: 3,
    text: 'Para a CredPago, as imobiliárias não são apenas clientes, são parceiras que contruibuem com o nosso propósito e levam mais inovação para o mercado imobiliário. Ter imobiliárias e corretores com a gente é o que faz a diferença!',
  },
];

const BuildByPeople = ({ data }) => {
  const isMobile = useResizer();

  return (
    <S.Wrapper>
      <S.Container>
        <UI.Row>
          <UI.Col style={{ alignSelf: 'center' }} responsive={{ xs: 12, md: 6 }}>
            <UI.Title
              level={2}
              fontWeight={700}
              splitLabel={['Construída por pessoas', 'e para pessoas']}
              style={
                isMobile
                  ? { textAlign: 'center', marginTop: 30 }
                  : {
                      display: 'flex',
                      flexDirection: 'column',
                      whiteSpace: 'nowrap',
                    }
              }
            />

            <S.WrapperDescription>
              {descriptions.map((description) => (
                <UI.Description key={description.id} color="darkBlue" style={{ textAlign: 'left' }}>
                  {description.text}
                </UI.Description>
              ))}
            </S.WrapperDescription>
          </UI.Col>

          <S.ColumnImg responsive={{ xs: 12, md: 6 }}>
            <S.WrapperImg>
              <S.ImgCouple fluid={data.Couple.childImageSharp.fluid} />
            </S.WrapperImg>
          </S.ColumnImg>
        </UI.Row>
      </S.Container>
    </S.Wrapper>
  );
};

export default BuildByPeople;
